/** @format */

"use client";
import React from "react";
import { motion } from "framer-motion";
// import Link from "next/link";
import { Link } from "react-router-dom";

// import Image from "next/image";

const transition = {
	type: "spring",
	mass: 0.5,
	damping: 11.5,
	stiffness: 100,
	restDelta: 0.001,
	restSpeed: 0.001,
};

export const MenuItem = ({
	setActive,
	active,
	item,
	children,
}: {
	setActive: (item: string | null) => void;
	active: string | null;
	item: string;
	children?: React.ReactNode;
}) => {
	return (
		<div
			onPointerEnter={(e) => { if (e.pointerType === 'mouse') setActive(item); }}
			className="relative md:mr-4"
		>
			<motion.p
				transition={{ duration: 0.3 }}
				onClick={() => setActive(active === item ? null : item)}
				className="cursor-pointer hover:opacity-[0.9] text-white text-sm md:text-base">
				{item}
			</motion.p>
			{active !== null && (
				<motion.div
					initial={{ opacity: 0, scale: 0.85, y: 10 }}
					animate={{ opacity: 1, scale: 1, y: 0 }}
					transition={transition}>
					{active === item && (
						<div className="absolute top-[calc(100%_+_1.7rem)] left-0 md:left-1/2 md:-translate-x-1/2 z-50">
							<motion.div
								transition={transition}
								layoutId="active"
								className="bg-black text-white backdrop-blur-sm rounded-2xl overflow-hidden border border-black/[0.2] border-white/[0.2] shadow-xl max-w-[calc(100vw-1.5rem)] md:max-w-none">
								<motion.div
									layout
									className="w-max h-full p-4 max-w-[calc(100vw-1.5rem)] md:max-w-none">
									{children}
								</motion.div>
							</motion.div>
						</div>
					)}
				</motion.div>
			)}
		</div>
	);
};

export const Menu = ({
	setActive,
	children,
}: {
	setActive: (item: string | null) => void;
	children: React.ReactNode;
}) => {
	return (
		<nav
			onPointerLeave={(e) => { if (e.pointerType === 'mouse') setActive(null); }}
			className="flex flex-row justify-center md:justify-between items-center w-[min(384px,calc(100vw-1rem))] md:w-full relative rounded-full border border-transparent bg-black text-white border-white/[0.2] shadow-input space-x-1 md:space-x-4 px-4 md:px-16 py-4 md:py-2 my-5">
			{children}
		</nav>
	);
};

export const ProductItem = ({
	title,
	description,
	href,
	src,
}: {
	title: string;
	description: string;
	href: string;
	src: string;
}) => {
	return (
		<Link to={href} className="flex space-x-2">
			<img
				src={src}
				width={140}
				height={70}
				alt={title}
				className="flex-shrink-0 rounded-md shadow-2xl"
			/>
			<div>
				<h4 className="text-xl font-bold mb-1 text-white">{title}</h4>
				<p className="text-neutral-700 text-sm max-w-[10rem] text-neutral-300 text-white">
					{description}
				</p>
			</div>
		</Link>
	);
};

export const HoveredLink = ({ children, href }: any) => {
	return (
		<Link
			to={href}
			className="text-white text-neutral-700 text-neutral-200 hover:text-white">
			{children}
		</Link>
	);
};
